module.exports = __webpack_public_path__ + "img/nopic.3ddf6e11.jpg";